


























import { Component, Vue } from 'vue-property-decorator';
import enter_into from '../../assets/image/enter_into.png';
// 声明组件*****************
@Component({
  components: {

  }
})
export default class SetUp extends Vue {
  // 属性*****************
  private enter_into: string = enter_into;
  private value: boolean = true;
  private popupVisible: boolean = false;
  private alarmDate: Array<string> = [];
  private slots: Array<any> = [
        {
            flex: 1,
            values: ['2015-01', '2015-02', '2015-03', '2015-04', '2015-05', '2015-06'],
            className: 'slot1',
            textAlign: 'right'
        }, {
            divider: true,
            content: '-',
            className: 'slot2'
        }, {
            flex: 1,
            values: ['2015-01', '2015-02', '2015-03', '2015-04', '2015-05', '2015-06'],
            className: 'slot3',
            textAlign: 'left'
        }
    ]
    created ():void {
        document.title = '设置';
    }
  // 方法*****************
   private onValuesChange(vue: Object,data: Array<string>): void{
       this.alarmDate = data;
   }
}
